import React from 'react'
import Icon from './CloseButton/Icon'
import IconWrapper from './CloseButton/IconWrapper'

function CloseButton({
  onClose,
  'data-cy': dataCy,
  style,
  size = 1,
}: ICloseButtonDispatch) {
  return (
    <IconWrapper
      data-cy={'close-button-onboarding'}
      size={size}
      style={style}
      alignCenter={true}
      justifyCenter={true}
      onClick={onClose}
    >
      <Icon
        data-cy={dataCy}
        style={size ? { fontSize: `${20 * size}px` } : {}}
      />
    </IconWrapper>
  )
}

export default CloseButton

export interface ICloseButtonDispatch {
  onClose: () => void
  style?: React.CSSProperties
  size?: number
  'data-cy'?: string
}
